import { takeEvery, put, call } from "redux-saga/effects";

// Accessory Redux States
import {
    CREATE_ACCESSORY,
    GET_ACCESSORY_DETAILS,
    GET_ACCESSORY_LISTING,
    UPDATE_ACCESSORY,
    ADD_REMARK,
    TOGGLE_FEATURE,
    BULK_ACTION,
    BULK_DELETE_ACCESSORY,
} from "./actionTypes.js";

import {
    createAccessorySuccess,
    createAccessoryFail,
    getAccessoryListingSuccess,
    getAccessoryListingFail,
    getAccessoryDetailsSuccess,
    getAccessoryDetailsFail,
    updateAccessorySuccess,
    updateAccessoryFail,
    addRemarkSuccess,
    addRemarkFail,
    toggleFeatureSuccess,
    toggleFeatureFail,
    bulkActionSuccess,
    bulkActionFail,
    bulkDeleteAccessorySuccess,
    bulkDeleteAccessoryFail,
} from "./actions.js";

import {
    accessoryCreateApi,
    accessoryDeleteApi,
    accessoryDetailsApi,
    accessoryListingApi,
    accessoryUpdateApi,
    accessoryBulkActionApi,
    accessoryToggleFeatureApi,
    accessoryAddRemarkApi,
} from "./accessoryApi.js";

function* fetchAccessoryListing({ payload }) {
    try {
        const response = yield call(accessoryListingApi, payload);
        yield put(getAccessoryListingSuccess(response));
    } catch (error) {
        yield put(getAccessoryListingFail(error));
    }
}

function* fetchAccessoryDetails({ payload }) {
    try {
        const response = yield call(accessoryDetailsApi, payload);
        yield put(getAccessoryDetailsSuccess(response));
    } catch (error) {
        yield put(getAccessoryDetailsFail(error));
    }
}

function* fetchAccessoryCreate({ payload }) {
    try {
        const response = yield call(accessoryCreateApi, payload);
        yield put(createAccessorySuccess(response));
    } catch (error) {
        yield put(createAccessoryFail(error));
    }
}

function* fetchAccessoryUpdate({ payload }) {
    try {
        const response = yield call(accessoryUpdateApi, payload);
        yield put(updateAccessorySuccess(response));
    } catch (error) {
        yield put(updateAccessoryFail(error));
    }
}

function* fetchAddRemark({ payload }) {
    try {
        const response = yield call(accessoryAddRemarkApi, payload);
        yield put(addRemarkSuccess(response));
    } catch (error) {
        yield put(addRemarkFail(error));
    }
}

function* fetchToggleFeature({ payload }) {
    try {
        const response = yield call(accessoryToggleFeatureApi, payload);
        yield put(toggleFeatureSuccess(response));
    } catch (error) {
        yield put(toggleFeatureFail(error));
    }
}

function* fetchBulkAction({ payload }) {
    try {
        const response = yield call(accessoryBulkActionApi, payload);
        yield put(bulkActionSuccess(response));
    } catch (error) {
        yield put(bulkActionFail(error));
    }
}

function* fetchBulkDeleteAccessory({ payload }) {
    try {
        const response = yield call(accessoryDeleteApi, payload);
        yield put(bulkDeleteAccessorySuccess(response));
    } catch (error) {
        yield put(bulkDeleteAccessoryFail(error));
    }
}

function* AccessorySaga() {
    yield takeEvery(GET_ACCESSORY_LISTING, fetchAccessoryListing);
    yield takeEvery(GET_ACCESSORY_DETAILS, fetchAccessoryDetails);
    yield takeEvery(CREATE_ACCESSORY, fetchAccessoryCreate);
    yield takeEvery(UPDATE_ACCESSORY, fetchAccessoryUpdate);
    yield takeEvery(ADD_REMARK, fetchAddRemark);
    yield takeEvery(TOGGLE_FEATURE, fetchToggleFeature);
    yield takeEvery(BULK_ACTION, fetchBulkAction);
    yield takeEvery(BULK_DELETE_ACCESSORY, fetchBulkDeleteAccessory);
}

export default AccessorySaga;